import { createSlice } from "@reduxjs/toolkit";
export const historySlice = createSlice({
    name: 'history',
    initialState: {
        byOrigin: {},
        byResource: {},
    },
    reducers: {
        clear: (state, { payload }) => {
            const { id, operation } = payload;
            if (!state.byResource[id]?.[operation])
                return;
            state.byResource[id][operation] = [];
        },
        push: (state, { payload }) => {
            const { id, operation, snapshot } = payload;
            state.byResource[id] = state.byResource[id] || { undo: [], redo: [] };
            state.byResource[id][operation] = [...state.byResource[id][operation], snapshot];
        },
        pushOrigin: (state, { payload }) => {
            const { origin, resourceID } = payload;
            state.byOrigin[origin] = state.byOrigin[origin] || [];
            state.byOrigin[origin] = [...state.byOrigin[origin].filter(id => id !== resourceID), resourceID];
        },
        dropLatest: (state, { payload }) => {
            const { id, operation } = payload;
            if (!state.byResource[id]?.[operation])
                return;
            state.byResource[id][operation] = state.byResource[id][operation].slice(0, -1);
        },
        dropFromOrigin: (state, { payload }) => {
            const { origin, resourceIDs } = payload;
            if (!state.byOrigin[origin])
                return;
            state.byOrigin[origin] = state.byOrigin[origin].filter(id => !resourceIDs.includes(id));
        },
    },
    selectors: {
        get: (state, { id, operation }) => state.byResource[id]?.[operation],
        getOrigin: (state, { origin }) => state.byOrigin[origin],
        peek: (state, { id, operation }) => state.byResource[id]?.[operation]?.at(-1),
        peekOrigin: (state, { origin }) => state.byOrigin[origin]?.at(-1),
    },
});
//# sourceMappingURL=historySlice.js.map